<template lang='pug' src='./home.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Modal from 'components/modal/modal'
import Hero from 'components/hero/hero'
import BlockIntro from 'components/block/block-intro/block-intro'
import BlockCtaModal from 'components/block/block-cta-modal/block-cta-modal'
import DividerText from 'components/divider/divider-text/divider-text'
import CustomHomeTabs from 'components/custom/custom-home-tabs/custom-home-tabs'
import SliderTestimonials from 'components/slider/slider-testimonials/slider-testimonials'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    Modal,
    Hero,
    BlockIntro,
    BlockCtaModal,
    DividerText,
    CustomHomeTabs,
    SliderTestimonials
  },
  methods: {
    change (direction, going) {
      if (going === 'out') {
        this.$store.dispatch('VIEW_NAV', true)
      }
      if (going === 'in' && direction.y === 'up') {
        this.$store.dispatch('VIEW_NAV', false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?1f5dd230